import { Checkall } from "./checkall"
import { Modal } from "./modal"
import { formatNumber } from "./helpers"

let _instances = new WeakMap<Element, Listing>();

type ListingOptions = {
    onLoad: (el: HTMLElement) => void,
}

class Listing {
    elContainer: HTMLElement;
    elPages:     NodeListOf<HTMLElement>;
    elColumns:   NodeListOf<HTMLElement>;

    elCheckAll: HTMLInputElement;
    elCheckAllBanner: HTMLElement;
    elCheckBoxes: NodeListOf<HTMLInputElement>;
    elSelectActions: NodeListOf<HTMLSelectElement>;

    allChecked: boolean = false;

    constructor(container: Element, opts: Partial<ListingOptions> = {}) {
        this.elContainer  = container as HTMLElement;

        this.elPages = container.querySelectorAll('ul.pagination[data-page-name] > li.page[data-page]');
        this.elColumns = container.querySelectorAll(".table-column-order[data-order-name]");

        this.init();

        _instances.set(container, this);
    }

    static instance(el: Element): Listing|null {
        return _instances.get(el);
    }

    init() {
        this.elPages.forEach((el) => {
            el.addEventListener("click", (e) => {

                const ul = el.parentNode as HTMLElement;

                var url = new URL(window.location.href);

                url.searchParams.set(ul.getAttribute('data-page-name'), el.getAttribute('data-page'));

                window.location.href = url.href;
            })
        })

        this.elColumns.forEach((el) => {
            el.addEventListener("click", (e) => {

                var url = new URL(window.location.href);

                url.searchParams.set(el.getAttribute('data-order-name')+'[]', el.getAttribute('data-order'));

                window.location.href = url.href;
            })
        })

        // Handle action checkboxes
        this.elSelectActions  = this.elContainer.querySelectorAll("select.table-action-select") as NodeListOf<HTMLSelectElement>;
        this.elCheckAll       = this.elContainer.querySelector("input.table-action-checkall") as HTMLInputElement;
        this.elCheckBoxes     = this.elContainer.querySelectorAll("input.table-action-checkbox") as NodeListOf<HTMLInputElement>;
        this.elCheckAllBanner = this.elContainer.querySelector(".table-checkall-banner");

        if (this.elCheckAll) {
            new Checkall(this.elCheckAll, this.elCheckBoxes, {
                afterChange: (changed: Array<HTMLInputElement>) => {
                    this.refreshSelectActions(this.elCheckAll.checked);
                },
            })
        }

        this.elCheckBoxes.forEach((el) => {
            el.addEventListener('change', (e) => {
                this.refreshSelectActions(false);
            })
        })

        if (this.elSelectActions.length) {
            this.initSelectActions();
        }


        if (this.elCheckAll && this.elCheckAll.checked && !(this.elCheckAll.indeterminate || false)) {
            this.refreshSelectActions(true);
        }
    }

    initSelectActions() {

        this.elSelectActions.forEach((el) => {
            el.addEventListener("change", (e) => {
                const index = el.selectedIndex;

                if (index > 0) {
                    this.onSelectAction(index, el.options[index]);
                }
            })
        });

        this.refreshSelectActions(false);
    }

    setUrlParams(base: string, params: Map<string, string>): string {
        let url = new URL(base, window.location.href);

        let urlParams = url.searchParams;

        params.forEach((v: string, k: string) => {
            urlParams.set(k, v);
        });

        return url.toString();
    }

    onSelectAction(index: number, el: HTMLOptionElement) {
        let selected: Array<string> = [];

        this.elCheckBoxes.forEach((el) => {
            if (el.checked) {
                selected.push(el.value)
            }
        })

        if (el.hasAttribute("data-post-url")) {

            const form = document.createElement("form");
            form.setAttribute("method", "POST")
            form.setAttribute("action", el.getAttribute("data-post-url"))
            
            const selInput = document.createElement("input");
            selInput.setAttribute("name", "selected");

            if (!this.allChecked) {
                selInput.setAttribute("value", selected.join(","));
            } else {
                selInput.setAttribute("value", "all");
            }

            form.appendChild(selInput);

            if (el.hasAttribute("data-csrf-name") && el.hasAttribute("data-csrf-value")) {
                const selCSRF = document.createElement("input");
                selCSRF.setAttribute("name",  el.getAttribute("data-csrf-name"));
                selCSRF.setAttribute("value", el.getAttribute("data-csrf-value"));
                form.appendChild(selCSRF);
            }

            document.body.appendChild(form);

            form.submit();

        } else if (el.hasAttribute("data-modal-url")) {
            

            const selValue = this.allChecked ? "all" : selected.join(",");

            const uri = this.setUrlParams(el.getAttribute("data-modal-url"), new Map([["selected", selValue]]))

            let modal = new Modal({
                "url": uri,
            })

            modal.addEventListener("modal.close", (e) => {
                modal.destroy();
            })

            modal.open();

        }

        this.elSelectActions.forEach((el) => {
            el.selectedIndex = 0;
        });
    }

    refreshSelectActions(checkall: boolean) {

        let nSelected = 0;
        this.elCheckBoxes.forEach((el) => {
            if (el.checked) {
                nSelected += 1
            }
        })

        let total = 0;
        this.elSelectActions.forEach((el) => {
            total = parseInt(el.getAttribute('data-total'));
        });

        if (this.allChecked) {
            nSelected = total;
        }

        if (this.elCheckAllBanner) {
            if (checkall && (total > nSelected || this.allChecked)) {
                const label = this.elCheckAllBanner.querySelector('[data-checkall-format]') as HTMLElement;

                if (this.allChecked) {
                    const currentFormat  = label.getAttribute('data-selected-format');
                    const clearFormat    = label.getAttribute('data-clear-format');

                    if (currentFormat) {
                        label.innerText = currentFormat.replace("[n]", formatNumber(total)).replace("[m]", formatNumber(total));
                    }

                    if (clearFormat) {
                        let btn = document.createElement("a");
                        btn.setAttribute("href", "#");
                        btn.innerText = clearFormat.replace('[n]', formatNumber(nSelected)).replace("[m]", formatNumber(total));
                        label.append(btn);

                        btn.addEventListener("click", (e) => {
                            e.preventDefault();

                            this.allChecked = false;

                            this.refreshSelectActions(true);
                        })
                    }

                } else {
                    const currentFormat  = label.getAttribute('data-selected-format');
                    const checkallFormat = label.getAttribute('data-checkall-format');

                    if (currentFormat) {
                        label.innerText = currentFormat.replace("[n]", formatNumber(nSelected)).replace("[m]", formatNumber(total));
                    }

                    if (checkallFormat) {
                        let btn = document.createElement("a");
                        btn.setAttribute("href", "#");
                        btn.innerText = checkallFormat.replace('[n]', formatNumber(nSelected)).replace("[m]", formatNumber(total));
                        label.append(btn);

                        btn.addEventListener("click", (e) => {
                            e.preventDefault();

                            this.allChecked = true;

                            this.refreshSelectActions(true);
                        })
                    }
                }

                this.elCheckAllBanner.classList.add("show");
            } else {
                this.elCheckAllBanner.classList.remove("show");
            }
        }

        this.elSelectActions.forEach((el) => {
            const preview = el.querySelector("option");
            const total   = parseInt(el.getAttribute('data-total'));
            const format  = preview.getAttribute('data-select-format');

            preview.innerText = format.replace("[n]", formatNumber(nSelected)).replace("[m]", formatNumber(total));

            if (nSelected == 0) {
                el.setAttribute("disabled", "disabled");
            } else {
                el.removeAttribute("disabled");
            }
        });
    }
}

export { Listing };
